module.exports = __webpack_public_path__ + "img/toast-close.d715b711.svg";